import * as Sentry from "@sentry/browser";
import mixpanel from "mixpanel-browser";
import { useEffect } from "react";

import useOrg from "./hooks/useOrg";

// Note: by "analytics" here we mean Mixpanel and Sentry, not the report analytics tools built into the app.
export default function useAnalytics() {
  const { loggedInUser } = useOrg();

  useEffect(() => {
    Sentry.setUser({
      id: loggedInUser.id,
      email: loggedInUser.email,
      name: loggedInUser.name,
      team: loggedInUser.team?.name,
      organisation: loggedInUser.org.name,
    });
  }, [loggedInUser]);

  useEffect(() => {
    mixpanel.set_group("organisation", [loggedInUser.org.id]);
    getSHA256Hash(loggedInUser.id)
      .then((id) => mixpanel.identify(id))
      .catch(() => mixpanel.identify(""));
  }, [loggedInUser]);
}

export const getSHA256Hash = async (input: string) => {
  const textAsBuffer = new TextEncoder().encode(input);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hash = hashArray.map((item) => item.toString(16).padStart(2, "0")).join("");
  return hash;
};
